import { pipe, when } from 'ramda';
import { getAccount } from './helpers';

// todo: have to split
export const handlePayPalViaSC = options => when(
    () => options.code === 'PayPalViaSC',
    (request) => {
        // delete `accountCode`
        const { accountCode, ...restRequest } = request;

        const BA_IMS_FIELD_NAME = 'bavalue';
        const UUID_IMS_FIELD_NAME = 'uuid';

        const labelToName = options.accountFields.reduce((acc, field) => {
            const label = field.label.toLocaleLowerCase();

            if (label === BA_IMS_FIELD_NAME || label === UUID_IMS_FIELD_NAME) {
                acc[label] = field.name;
            }

            return acc;
        }, {});

        if (BA_IMS_FIELD_NAME in labelToName) {
            // todo 1. uuidForFraud should be generated on init (see backbone)
            // todo 2. it's unclear what `data` is and where it comes from
            const { data, uuidForFraud } = options;
            // todo getAccount should accept `accountCode` and `accounts`. Need to fix this.
            const { accountData = {} } = getAccount({ ...options, ...data });
            const isOriginBA = accountData[labelToName[BA_IMS_FIELD_NAME]];
            const isBAChecked = request.specificParams[labelToName[BA_IMS_FIELD_NAME]];

            if (isBAChecked) {
                restRequest.subMethodsCodes = ['ReferenceTransaction'];

                if (isOriginBA && UUID_IMS_FIELD_NAME in labelToName) {
                    restRequest.specificParams[labelToName[UUID_IMS_FIELD_NAME]] = uuidForFraud;
                }
            }
        }

        return restRequest;
    }
);
export const handleDotPayBankTransferDeposit = ({ code }) => when(
    () => code === 'DotpayBankTransfer',
    (request) => {
        const {
            accountCode,
            specificParams: {
                subMethodsCodes,
                ...restParams
            },
            ...rest
        } = request;

        return {
            ...rest,
            specificParams: restParams,
            subMethodsCodes: [subMethodsCodes]
        };
    }
);
export const handleDotPayBlikDeposit = ({ code }) => when(
    ({ specificParams }) => code === 'DotpayBlik' && specificParams.altAccount,
    (request) => {
        const {
            specificParams: {
                altAccount: selectedAccount,
                ...rest
            }
        } = request;

        return {
            ...request,
            selectedAccount,
            specificParams: rest
        };
    }
);
export const handleDotPayCardDeposit = ({ code }) => when(
    () => code === 'DotpayCard',
    (request) => {
        const {
            accountCode,
            specificParams: {
                field2,
                ...restParams
            },
            ...rest
        } = request;

        return {
            ...rest,
            specificParams: field2 === 'add'
                ? restParams
                : request.specificParams
        };
    }
);
export const handleSpecialPmsDeposit = options => pipe(
    handleDotPayBlikDeposit(options),
    handleDotPayCardDeposit(options),
    handleDotPayBankTransferDeposit(options),
    handlePayPalViaSC(options)
);
